const SERVICE_NAME = 'ARTICLES_SERVICE';

export const ARTICLES_FETCH_REQUEST = SERVICE_NAME + '_FETCH_REQUEST';
export const ARTICLES_FETCH_SUCCESS = SERVICE_NAME + '_FETCH_SUCCESS';
export const ARTICLES_FETCH_FAILURE = SERVICE_NAME + '_FETCH_FAILURE';

export const ARTICLES_SET_SELECTED = SERVICE_NAME + '_SET_SELECTED';

export const ARTICLES_VIEWS_FETCH_REQUEST = SERVICE_NAME + '_VIEWS_FETCH_REQUEST';
export const ARTICLES_VIEWS_FETCH_SUCCESS = SERVICE_NAME + '_VIEWS_FETCH_SUCCESS';
export const ARTICLES_VIEWS_FETCH_FAILURE = SERVICE_NAME + '_VIEWS_FETCH_FAILURE';

export const ARTICLES_LIKES_FETCH_REQUEST = SERVICE_NAME + '_LIKES_GET_REQUEST';
export const ARTICLES_LIKES_FETCH_SUCCESS = SERVICE_NAME + '_LIKES_GET_SUCCESS';
export const ARTICLES_LIKES_FETCH_FAILURE = SERVICE_NAME + '_LIKES_GET_FAILURE';

export const ARTICLES_LIKES_INC_REQUEST = SERVICE_NAME + '_LIKES_INC_REQUEST';

export const ARTICLES_RESET_TABLE_OF_CONTENTS = SERVICE_NAME + '_RESET_TABLE_OF_CONTENTS';
export const ARTICLES_PUSH_ARTICLE_CONTENT = SERVICE_NAME + '_PUSH_ARTICLE_CONTENT';
